export const styles = {
  // Column layout so the grid takes every pixel left under the header row.
  pageMainBox: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
  },
  headerGrid: { flexShrink: 0 },
  dataTable: { flex: 1, minHeight: 0 },
  resultStack: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "4px",
  },
  triggerDialogLoading: { mx: "250px" },
  textFieldStack: { width: "500px", mt: "5px" },
};
